import React, { useState, useEffect } from "react";

interface LogoProps {
  light: boolean;
  width: string;
  height?: string;
}

const appName = process.env.REACT_APP_NAME || "Settlement System";
const theme = process.env.REACT_APP_THEME || "default";
const logoExtension = process.env.REACT_APP_LOGO_EXTENSION || "png";

const Logo: React.FC<LogoProps> = ({ light, width, height }) => {
  const [logoSrc, setLogoSrc] = useState("");
  useEffect(() => {
    import(`../themes/${theme}/img/${light ? "logo-light" : "logo"}.${logoExtension}`)
      .then((module) => {
        setLogoSrc(module.default);
      })
      .catch((error) => {
        console.error(`Failed to load logo for ${theme}:`, error);
      });
  }, [theme]); // eslint-disable-line

  return <img src={logoSrc} alt={appName} width={width} height={height}/>;
};

export default Logo;
